import { v4 } from 'uuid';
class organizationHeaders {
    constructor(user_id) {
        this.user_id = user_id
        this.trace_id = v4()
    }

    get() {
        return {
            "user_id": this.user_id,
            "trace_id": v4()
        }
    }
}

class organizationAddEntity {
    constructor(name, parent) {
        this.name = name
        this.parent = parent
    }

    get() {
        return {
            name: this.name,
            parent: this.parent
        }
    }
}

class organizationUpdateEntity {
    constructor(deptId, name, parent) {
        this.deptId = deptId
        this.name = name
        this.parent = parent
    }

    get() {
        return {
            deptId: this.deptId,
            name: this.name,
            parent: this.parent
        }
    }
}


class SaveMenuAuthEntity {
    constructor(menuIds, name, menuAuthGroupId) {
        this.menuAuthGroupId = menuAuthGroupId
        this.menuIds = menuIds
        this.name = name
    }

    get() {
        return {
            menuAuthGroupId: this.menuAuthGroupId,
            menuIds: this.menuIds,
            name: this.name
        }
    }
}

class SaveAccountEntity {
    constructor(account) {
        this.deptId = account.deptId
        this.username = account.username
        this.email = account.email
        this.initPassword = account.initPassword
        this.maskFlag = account.maskFlag
        this.viewYN = account.viewYN
        this.modYn = account.modYn
        this.menuAuthGroupId = account.menuAuthGroupId
        this.name = account.name
        this.partnerAuthGroupId = account.partnerAuthGroupId
        this.phone = account.phone // 010-1111-1111
        this.status = account.status
        this.description = account.description
        this.mngNotice = account.mngNotice
        this.requireSmsAuth = account.requireSmsAuth
    }

    get() {
        return {
            deptId: this.deptId,
            username: this.username,
            email: this.email,
            initPassword: this.initPassword,
            maskFlag: this.maskFlag,
            viewYN: this.viewYN,
            modYn: this.modYn,
            menuAuthGroupId: this.menuAuthGroupId,
            name: this.name,
            partnerAuthGroupId: this.partnerAuthGroupId,
            phone: this.phone,
            status: this.status,
            description: this.description,
            mngNotice: this.mngNotice,
            requireSmsAuth: this.requireSmsAuth,
        }
    }
}

class UpdateAccountEntity {
    constructor(account) {
        this.deptId = account.deptId
        this.username = account.username
        this.email = account.email
        this.maskFlag = account.maskFlag
        this.menuAuthGroupId = account.menuAuthGroupId
        this.name = account.name
        this.partnerAuthGroupId = account.partnerAuthGroupId
        this.phone = account.phone // 010-1111-1111
        this.status = account.status
        this.viewYN = account.viewYN
        this.modYn = account.modYn
        this.mngNotice = account.mngNotice
        this.userId = account.userId
        this.description = account.description
        this.requireSmsAuth = account.requireSmsAuth
    }

    get() {
        return {
            deptId: this.deptId,
            username: this.username,
            email: this.email,
            maskFlag: this.maskFlag,
            menuAuthGroupId: this.menuAuthGroupId,
            name: this.name,
            partnerAuthGroupId: this.partnerAuthGroupId,
            phone: this.phone,
            status: this.status,
            viewYN: this.viewYN,
            modYn: this.modYn,
            mngNotice: this.mngNotice,
            userId: this.userId,
            description: this.description,
            requireSmsAuth: this.requireSmsAuth
        }
    }
}

class PasswordInitializeEntity {
    constructor(email, name) {
        this.email = email
        this.name = name
    }

    get() {
        return {
            email: this.email,
            name: this.name,
        }
    }
}

const entity = {
    organizationHeaders,
    organizationAddEntity,
    organizationUpdateEntity,
    SaveAccountEntity,
    UpdateAccountEntity,
    PasswordInitializeEntity,
    SaveMenuAuthEntity
}

export default entity
